"use strict";

exports.__esModule = true;
exports.Workloads = exports.Stats = exports.SetupHardwareSection = exports.Header = exports.Details = void 0;
var _Details = require("./Details");
exports.Details = _Details.Details;
var _Header = require("./Header");
exports.Header = _Header.Header;
var _SetupHarwareSection = require("./SetupHarwareSection");
exports.SetupHardwareSection = _SetupHarwareSection.SetupHardwareSection;
var _Stats = require("./Stats");
exports.Stats = _Stats.Stats;
var _Workloads = require("./Workloads");
exports.Workloads = _Workloads.Workloads;